export const GET_SCREENINGS_AVAILABLE = "GET";
export const DELETE_PROFILE = "DELETE";
export const GET_FILTER_LIST = "GET_FILTER_LIST";
export const GET_SCREENINGS_ONHOLD = "GET_SCREENINGS_ONHOLD";
export const UPDATE_HOLD = "UPDATE_HOLD";
export const REQUEST_HOLD = "REQUEST_HOLD";
export const GET_SORT_LIST = "GET_SORT_LIST";
export const GET_HOLDSORT_LIST = "GET_HOLDSORT_LIST";
